import { useParams } from "react-router-dom";
import { useGetDownloadBatch } from "./api/queries";
import DownloadsView from "./DownloadsView";

/*
 * Public download landing page — app.mvbth.com/downloads/:token.
 *
 * A calm, trustworthy page for the whole download: the download is the hero,
 * the Movebooth mark a quiet accent. One page renders every state off the
 * public metadata endpoint's `status` + HTTP code (never a UI switcher):
 * loading · processing (polls) · ready-single · ready-multi · partial · expired
 * (410) · not-found (404) · error. Ported class-for-class from the locked
 * Direction-A design so the build is indistinguishable from the mockup, and
 * reacts to prefers-color-scheme for light/dark (the repo's first theme-aware
 * surface — see downloads.css). Rendered bare (no dashboard chrome) via App's
 * isBlankPage check.
 *
 * This is the thin data wrapper; the presentational tree lives in DownloadsView.
 */
const DownloadsPage = () => {
  const { token } = useParams();
  const { data, isLoading, error, refetch } = useGetDownloadBatch(token);

  return (
    <DownloadsView
      token={token}
      isLoading={isLoading}
      data={data}
      error={error}
      onRetry={() => refetch()}
    />
  );
};

export default DownloadsPage;
